import classNames from "classnames";
import NftImage from "components/images/NftImage";
import { BasicProps } from "components/types/BasicProps";
import { useNftTitle } from "logic/hooks";
import { INft } from "logic/types/nft/INft";
import { FC } from "react";
import { accountLiterals } from "../literals";

type Props = BasicProps & {
  nft: INft;
};

const { traitsTitle } = accountLiterals.nftInfoPanel;

export const NftInfoPanel: FC<Props> = (props) => {
  const { nft, className } = props;
  const title = useNftTitle(nft);

  return (
    <div
      className={classNames(
        "border-2 border-hovercolor rounded-[15px] p-[15px] bg-secondary flex gap-[15px] text-xs",
        className
      )}
    >
      <div className="flex flex-col gap-2.5">
        <NftImage
          className="w-[200px] h-[200px] rounded-[10px]"
          src={nft.image}
          alt={nft.alt}
        />
        <div className="flex flex-col gap-[5px]">
          <span className="w-[200px] whitespace-break-spaces font-bold text-uyellow">
            {title || ""}
          </span>
          <span className="border-b border-b-uyellow font-medium">
            {nft.name}
          </span>
        </div>
      </div>
      <div className="pt-[5px] flex flex-col gap-2.5 text-xs">
        <span className="text-uyellow font-bold">{traitsTitle}</span>
        <ul className="h-[249px] overflow-auto scrollbar pt-[5px] flex flex-col gap-2.5 border-t border-t-white border-opacity-25">
          {nft.attributes.map((attribute) => (
            <li
              key={attribute.key}
              className="pb-[5px] border-b-2 border-b-white border-opacity-25 flex flex-col"
            >
              <span className="font-bold">{attribute.key}</span>
              <span className="font-medium">{attribute.value}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
